import { AccountDetailModule } from '@/components/modules/AccountDetail/AccountDetail';
import { ALL_APP_ROLES, ALL_APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

import { DYNAMIC_PAGE_PATHS } from '../../shared/pathRoutes';

export const PAGE_ACCOUNT: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.ACCOUNT,
  schemesByRoles: [
    {
      roles: [...ALL_APP_ROLES],
      titleTextId: 'ACCOUNT',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <AccountDetailModule
          permissions={{
            view: ALL_APP_USER_TYPES,
          }}
        />
      ),
    },
  ],
};
